module.exports = __webpack_public_path__ + "img/pin_orange.b441a084.svg";